export default __webpack_public_path__ + "static/media/A5_COPY.58a855ac.png";